import React from 'react';
import styled from 'styled-components';


const TextWrapper = styled.div`
  padding: 0.5rem;

  @media(min-width: 1000px) {
      padding: 1.2rem;
  }
`

export { TextWrapper }